import React from 'react';
import { isMobileDevice } from 'utils/browserCheck';
import ReportCardDesktop from './ReportCardDesktop';
import ReportCardMobileView from './ReportCardMobile';

const ReportCardWrapper = ({
  hasGraderFeedback,
  canViewRecordingLink,
  api,
  currentUserId,
  ratings,
  currentUserName,
  progressUserId,
  answers,
}) => {
  return isMobileDevice() ? (
    <ReportCardMobileView
      hasGraderFeedback={hasGraderFeedback}
      canViewRecordingLink={canViewRecordingLink}
      api={api}
      currentUserId={currentUserId}
      ratings={ratings}
      currentUserName={currentUserName}
      progressUserId={progressUserId}
      answers={answers}
    />
  ) : (
    <ReportCardDesktop
      hasGraderFeedback={hasGraderFeedback}
      canViewRecordingLink={canViewRecordingLink}
      api={api}
      currentUserId={currentUserId}
      ratings={ratings}
      currentUserName={currentUserName}
      progressUserId={progressUserId}
      answers={answers}
    />
  );
};

export default ReportCardWrapper;
